import { Injectable } from '@angular/core';
import { HttpClient, HttpErrorResponse, HttpHeaders } from '@angular/common/http';

import { catchError, retry, timeout } from 'rxjs/operators';
import { Observable, throwError } from 'rxjs';

const CONNECTION_TIMEOUT = 60 * 1000;

@Injectable({
	providedIn: 'root'
})
export class MigrationService {
	constructor(private http: HttpClient) {}

	get(url: string, headers?: HttpHeaders): Observable<any> {
		return this.http
			.get(url, { headers })
			.pipe(
				retry(1),
				timeout(CONNECTION_TIMEOUT),
				catchError(error => {
					let errorMsg: string;
					if (error.error instanceof ErrorEvent) {
						errorMsg = `Error: ${error.error.message}`;
					} else {
						errorMsg = this.getServerErrorMessage(error);
					}

					return throwError(errorMsg);
				})
			);
	}

	post(url: string, body: any, headers?: HttpHeaders): Observable<any> {
		return this.http
			.post(url, body, {headers})
			.pipe(
				retry(1),
				timeout(CONNECTION_TIMEOUT),
				catchError(error => {
					let errorMsg: string;
					if (error.error instanceof ErrorEvent) {
						errorMsg = `Error: ${error.error.message}`;
					} else {
						errorMsg = this.getServerErrorMessage(error);
					}

					return throwError(errorMsg);
				})
			);
	}

	patch(url: string, body: any, headers?: HttpHeaders): Observable<any> {
		return this.http
			.patch(url, body, {headers})
			.pipe(
				retry(1),
				timeout(CONNECTION_TIMEOUT),
				catchError(error => {
					let errorMsg: string;
					if (error.error instanceof ErrorEvent) {
						errorMsg = `Error: ${error.error.message}`;
					} else {
						errorMsg = this.getServerErrorMessage(error);
					}

					return throwError(errorMsg);
				})
			);
	}

	private getServerErrorMessage(error: HttpErrorResponse): string {
		switch (error.status) {
		case 404: {
			return `Not Found: ${error.message}`;
		}
		case 403: {
			return `Access Denied: ${error.message}`;
		}
		case 500: {
			return `Internal Server Error: ${error.message}`;
		}
		default: {
			return `Unknown Server Error: ${error.message}`;
		}

		}
	}
}
